/**
 * Constructs a query string from an object of parameters.
 *
 * @param {Object} params - Key-value pairs representing query parameters.
 * @returns {string} - A query string starting with '?' or an empty string if no valid parameters.
 *
 * Example:
 * constructQueryString({ page: 1, limit: 10, sort: 'name' });
 * // Output: "?page=1&limit=10&sort=name"
 */

// export const constructQueryString = (params = {}) => {
//     const queryParams = Object.entries(params)
//         .filter(([_, value]) => value !== undefined && value !== null) // Filter out undefined or null values
//         .map(([key, value]) => `${key}=${value}`);
//     return queryParams.length ? `?${queryParams.join('&')}` : '';
// };

export const constructQueryString = (params = {}) => {
  const queryParams = Object.entries(params)
    .filter(
      ([key, value]) =>
        value !== undefined &&
        value !== null &&
        !(key === '_q' && value === ''), // Skip _q with empty value
    )
    .map(([key, value]) => `${key}=${value}`);
  return queryParams.length ? `?${queryParams.join('&')}` : '';
};
